import { FileTextIcon, DownloadIcon, ActivityIcon, SmartphoneIcon } from 'lucide-react';

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/fqibuJ5KLmw65rEQEWQAYx/Coleccion_Sigma_Smart_de_Triatlon.webp';

export const heroChips = [
  { icon: FileTextIcon, label: '100% Visual PDF' },
  { icon: DownloadIcon, label: 'Descarga inmediata' },
  { icon: ActivityIcon, label: 'Todos los niveles' },
  { icon: SmartphoneIcon, label: 'Android & iOS' },
];

export const disciplines = ['Natación', 'Ciclismo', 'Running', 'Nutrición', 'Progreso', 'Estrategia de carrera'];
